<!-- eslint-disable -->
<template lang="pug">
    cs-loader(v-if="!params")
    .game-info__individual-settings(v-else)
        multiplayer-tiny-setting.game-info__difficult(
            :label="`${currentDifficultyValue} Р`",
            :value="currentDifficultyValue",
            :min="difficulties[0].value",
            :max="difficulties[difficulties.length - 1].value",
            :disabled="!isGamePaused",
            @increase="handleDifficultyIncrease",
            @decrease="handleDifficultyDecrease",
        )
        multiplayer-tiny-setting.game-info__actions(
            :label="`${params.amountOfActions} Д`",
            :value="params.amountOfActions",
            :min="amountsOfActions[0]",
            :max="amountsOfActions[amountsOfActions.length - 1]",
            :disabled="!isGamePaused",
            @increase="handleAmountOfActionsIncrease",
            @decrease="handleAmountOfActionsDecrease",
        )
        multiplayer-tiny-setting.game-info__choose-time(
            :label="`${params.amountOfUnknowns} Н`",
            :value="params.amountOfUnknowns",
            @increase="handleAmountOfUnknownsIncrease",
            @decrease="handleAmountOfUnknownsDecrease",
            :min="1",
            :max="params.amountOfActions - 1",
            :disabled="!isGamePaused && params.amountOfActions < 3",
        )
</template>

<script>
    /*eslint-disable*/
    import { mapState } from 'vuex';

    const PARAMETERS_UPDATE_EVENT = 'parametersUpdate';

    export default {
        mounted () {
            this.parameters = this.paramsArray;
            this.params = this.paramsArray[this.currentUserPosition];
            this.currentDifficultyIndex = this.difficulties.findIndex((difficulty) => {
                return difficulty.name === this.params.difficult;
            });
        },
        props: {
            currentUserPosition: {
                type: Number,
                default: 0,
            },
            isGamePaused: {
                type: Boolean,
                default: false,
            }
        },
        watch: {
            params: {
                handler (value, oldValue) {
                    if (oldValue !== null) {
                        this.parameters[this.currentUserPosition] = value;
                        this.$store.dispatch('setParamsArray', this.parameters);
                        this.$emit(PARAMETERS_UPDATE_EVENT);
                    }
                },
                deep: true,
            },
            'params.difficult': {
                handler (value) {
                    this.currentDifficultyIndex = this.difficulties.findIndex((difficulty) => {
                        return difficulty.name === value;
                    });
                }
            }
        },
        data () {
            return {
                parameters: null,
                params: null,
                currentDifficultyIndex: 0,
                difficulties: [
                    {
                        label: this.$i18n.t('common.common_gameSetting_singleDigitNum'),
                        name: 'Однозначные цифры',
                        $isDisabled: false,
                        value: 1,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_doubleDigitsNum'),
                        name: 'Двузначные цифры',
                        $isDisabled: false,
                        value: 2,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_tripleDigitsNum'),
                        name: 'Трехзначные цифры',
                        $isDisabled: false,
                        value: 3,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_fourDigitsNum'),
                        name: 'Четырехзначные цифры',
                        $isDisabled: false,
                        value: 4,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_fiveDigitsNum'),
                        name: 'Пятизначные цифры',
                        $isDisabled: false,
                        value: 5,
                    }
                ],
                amountsOfActions: [...Array(11).keys()].slice(2),
            }
        },
        methods: {
            handleDifficultyIncrease () {
                this.currentDifficultyIndex += 1;
                this.params.difficult = this.difficulties[this.currentDifficultyIndex].name;
            },
            handleDifficultyDecrease () {
                this.currentDifficultyIndex -= 1;
                this.params.difficult = this.difficulties[this.currentDifficultyIndex].name;
            },
            handleAmountOfActionsIncrease () {
                this.params.amountOfActions = this.amountsOfActions[this.amountsOfActions.indexOf(this.params.amountOfActions) + 1];
            },
            handleAmountOfActionsDecrease () {
                this.params.amountOfActions = this.amountsOfActions[this.amountsOfActions.indexOf(this.params.amountOfActions) - 1];
                if (this.params.amountOfUnknowns !== 1) {
                    this.params.amountOfUnknowns -= 1;
                }
            },
            handleAmountOfUnknownsIncrease () {
                this.params.amountOfUnknowns += 1;
            },
            handleAmountOfUnknownsDecrease () {
                this.params.amountOfUnknowns -= 1;
            }
        },
        computed: {
            ...mapState({
                paramsArray: state => state.trainer.paramsArray,
            }),
            currentDifficultyValue () {
                if (this.params) {
                    let difficulty = this.difficulties.find(difficulty => difficulty.name === this.params.difficult);
                    return difficulty ? difficulty.value : 1;
                }
                return 1;
            },
        }
    }

</script>

<style scoped lang="scss">
    .game-info__individual-settings {
        display: flex;
        justify-content: center;
        margin-top: 10px;
        align-self: center;
    }
</style>